module.exports = __webpack_public_path__ + "static/bbyxydyfsyy-47cf2e2d1693f37612350cd7f9c48b76.jpg";